<template>
  <div id="quickview" class="quickview-wrapper scroll-candidates" v-bind:class="{ open: toggleCandidatesSidebar }" data-pages="quickview">

    <div class="tab-content">
      <div class="tab-pane active no-padding">
        <div class="view-port clearfix">
          <div class="view bg-white">
            <div class="navbar navbar-default navbar-margin" v-bind:class=classByListType >
              <div class="navbar-inner">
                <div class="view-heading">
                  <a class="btn-link quickview-toggle" data-toggle-element="#quickview" data-toggle="quickview"><i class="pg-close close-sidebar cursor-hand"></i></a>
                  <label class="m-t-10"> {{ candidatesList.total }} {{ $t("candidate.number") }} </label>
                </div>
              </div>
            </div>

            <div v-for="candidate in candidatesList.data">
              <div class="list-view boreded no-top-border">
                <p class="p-l-10 ">
                  <span class="text-master"> {{ candidate.first_name }} {{ candidate.last_name }} </span>
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
      <paginate v-if="totalPages > 1"
                :page-count="parseInt(totalPages)"
                :click-handler="pageChanged"
                :container-class="'pagination m-t-15'"
                :page-class="'page-item'"
                :hide-prev-next="true"
                :prev-text="$t('pagination.previous')"
                :next-text="$t('pagination.next')"
      />
    </div>
  </div>
</template>

<script>
  import Paginate from 'vuejs-paginate'
  import { mapGetters } from 'vuex'

  export default {
    name: "CandidatesListSidebar",
    props: ['candidatesList', 'candidatesCount', 'offer', 'toggleCandidatesSidebar', 'candidatesListType'],
    components: { Paginate },
    computed: {
      ...mapGetters({
        page: 'offers/candidatesListPage',
      }),
      totalPages() {
        return this.candidatesList.totalPages
      },
      classByListType() {
        return {
          'alert-success': this.candidatesListType == 'default',
          'potential-candidates': this.candidatesListType == 'potential',
          'refusing-candidates': this.candidatesListType == 'refusing',
          'selecting-candidates': this.candidatesListType == 'selecting'
        }
      }
    },
    methods: {
      pageChanged: function(page) {
        this.$emit('pageChanged', page)
      }
    }
  }
</script>

<style scoped>

.close-sidebar {
  color: #11705c;
  margin-top: 10px;
}

.cursor-hand {
  cursor: pointer;
}

.scroll-candidates {
  overflow: auto;
}

.navbar-margin {
  margin-bottom: 10px;
}

.potential-candidates {
  background-color: #ebebeb;
}

.refusing-candidates {
  background-color: #f5bbac;
}

.selecting-candidates {
  background-color: #bce3d7;
}

</style>



// WEBPACK FOOTER //
// src/components/offers/CandidatesListSidebar.vue